import React, { Component } from 'react'
import { get, isEmpty } from 'lodash'
import { Col, Row } from 'antd'
import checkboxHOC from 'react-table-v6/lib/hoc/selectTable'
import CustomTable from '../../../../elements/Table/CustomTable'
import InfoText from '../../../../elements/InfoText'
import CustomSelect from '../../../../elements/Select/CustomSelect'

const CheckboxTable = checkboxHOC(CustomTable)

class Existing extends Component {
  state = {
    selection: [],
  }
  columns = [
    {
      Header: 'Full Name',
      accessor: 'fn',
    },
    {
      Header: 'Email',
      accessor: 'email.label',
    },
    {
      Header: 'Phone',
      accessor: 'phone.label',
    },
    {
      Header: 'Mobile',
      accessor: 'mobile.label',
    },
  ]

  render() {
    const {
      toggleSelection,
      selection,
      isSelected,
      members,
      fetchingMembers,
      type,
      onChangeType,
      fetchMembers,
    } = this.props
    const checkboxProps = {
      selectType: 'radio',
      toggleSelection,
      isSelected,
      selection,
    }
    return (
      <div style={{ marginTop: 20 }}>
        <Row style={{ textAlign: 'left' }}>
          <Row>
            <InfoText text={'Select a current Phonebook Contact or Skip for Creating a new Phone Contact'} />
          </Row>
          <br />
          <br />
          <Col span={1}>
            <span>Type: </span>
          </Col>
          <Col span={5}>
            <CustomSelect
              onChange={onChangeType}
              value={type}
              data={[
                { key: 'individual', value: 'Individual' },
                { key: 'organisation', value: 'Organisation' },
              ]}
            />
          </Col>
          <br />
          <br />
          <CheckboxTable
            columns={this.columns}
            data={members}
            isFilterable={true}
            fetch={fetchMembers}
            fetching={fetchingMembers}
            {...checkboxProps}
          />
        </Row>
      </div>
    )
  }
}

export default Existing
